import React from 'react'
import { useTranslation } from 'react-i18next'

import { Icon, Timer } from 'src/components/ui'
import { calculateCountdown } from 'src/utils/calculateCountdown'
import { changeFormatOfDate } from 'src/utils/changeFormatOfDate'
import { formattedText } from 'src/utils/formattedText'

import { HistoryParticipationType } from '../../BanksParticipation.types'
import styles from './Bank.module.scss'

interface Props {
  variant: 'broken' | 'unbroken'
  bank: HistoryParticipationType
}

const Bank: React.FC<Props> = ({ bank, variant }) => {
  const { type, User, Bottle } = bank
  const { t } = useTranslation()

  const isWinner = type === 'WIN'

  const { time } = calculateCountdown(Bottle.available_until, Bottle.start_date)

  return (
    <div className={styles.bank}>
      <div className={styles.bank_header}>
        <div className={styles.bank_title}>
          <Icon name={type + '_HISTORY_PARTICIPATION'} />
          <p>{t(`history_participations.bank.titles.${type}`)}</p>
        </div>

        {variant === 'broken' ? (
          <div className={`${styles.bank_amount} ${isWinner ? styles.winner : styles.defeat}`}>
            <p>{`${isWinner ? '+' : '-'} ${formattedText(bank.amount || 0)}`}</p>
            <Icon name='star' />
          </div>
        ) : (
          <Timer className={styles.bank_timer} time={time || '00:00:00'} />
        )}
      </div>

      <div className={styles.bank_main}>
        <div>
          <p className={styles['bank_main-subtitle']}>{t('history_participations.bank.titles.name')}</p>
          <p className={styles['bank_main-title']}>{Bottle.name}</p>
        </div>
        <div>
          <p className={styles['bank_main-subtitle']}>{t('history_participations.bank.titles.owner')}</p>
          <p className={styles['bank_main-title']}>{User.username}</p>
        </div>
        {variant === 'broken' && (
          <div>
            <p className={styles['bank_main-subtitle']}>{t('history_participations.bank.titles.periodOfTime')}</p>
            <p
              className={styles['bank_main-title']}
            >{`${changeFormatOfDate(Bottle.start_date.split('T')[0])} - ${changeFormatOfDate(Bottle.available_until.split('T')[0])}`}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Bank
